import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { ArrowLink } from 'inside-out/components/shared/arrowLink';
import { PageHeader } from 'inside-out/components/shared/pageHeader';
import { Cards } from 'inside-out/components/shared/cards';
import { PolicyCard } from 'inside-out/components/shared/cards/policyCard';

import BG from 'inside-out/images/policy-service-development/bg.svg';
import NSWIcon from 'inside-out/images/policy-service-development/nsw.svg';
import AustraliaIcon from 'inside-out/images/policy-service-development/australia.svg';

import {
	wrapperStyle,
	innerWrapperStyle,
	quadrantsWrapperStyle,
	contentSectionStyle,
	cardSectionStyle,
	titleStyle,
	textStyle,
} from 'inside-out/page-styles/policy-and-service-development';

import { pink } from 'inside-out/global-styles';

export default class PolicyServiceDevelopmentPage extends React.PureComponent {
	static propTypes = {
		data: PropTypes.shape({
			allContentJson: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							main_heading: PropTypes.string.isRequired,
							main_body: PropTypes.string.isRequired,
							left_tile_heading: PropTypes.string.isRequired,
							left_tile_body: PropTypes.string.isRequired,
							left_tile_link_text: PropTypes.string.isRequired,
							left_tile_link_url: PropTypes.string.isRequired,
							right_tile_heading: PropTypes.string.isRequired,
							right_tile_body: PropTypes.string.isRequired,
							right_tile_link_text: PropTypes.string.isRequired,
							right_tile_link_url: PropTypes.string.isRequired,
							subheading: PropTypes.string.isRequired,
							body: PropTypes.string.isRequired,
							attachments: PropTypes.arrayOf(
								PropTypes.shape({
									title: PropTypes.string.isRequired,
									file: PropTypes.string.isRequired,
								})
							).isRequired,
						}),
					})
				),
			}),
		}),
	};

	render() {
		const { node } = this.props.data.allContentJson.edges[0];

		return (
			<div className={wrapperStyle}>
				<Helmet title={node.main_heading}>
          <meta property="og:type" content="website"/>
          <meta property="og:title" content={node.main_heading}/>
          <meta name="description" content={node.main_body}/>
          <meta property="og:description" content={node.main_body}/>
        </Helmet>

				<PageHeader
					background={`${pink} url(${BG}) no-repeat bottom right`}
					titleText={node.main_heading}
					subTitleText={node.main_body}
					subTitleTextColor="#fff"
					titleTextColor="#fff"
				/>

				<div className={innerWrapperStyle}>
					<div className={quadrantsWrapperStyle}>
						<section>
							<img src={NSWIcon} alt="New South Wales" />
							<h1>{node.left_tile_heading}</h1>
							<div dangerouslySetInnerHTML={{ __html: node.left_tile_body }} />
							<ArrowLink to={node.left_tile_link_url}>{node.left_tile_link_text}</ArrowLink>
						</section>
						<section>
							<img src={AustraliaIcon} alt="Australia" />
							<h1>{node.right_tile_heading}</h1>
							<div dangerouslySetInnerHTML={{ __html: node.right_tile_body }} />
							<ArrowLink to={node.right_tile_link_url}>{node.right_tile_link_text}</ArrowLink>
						</section>
					</div>
				</div>
				<section className={contentSectionStyle()}>
					<div className={innerWrapperStyle}>
						<header>
							<h1 className={titleStyle}>{node.subheading}</h1>
						</header>
						<div className={textStyle} dangerouslySetInnerHTML={{ __html: node.body }} />
						<div className={cardSectionStyle()}>
							<Cards columns={4}>
								{node.attachments.map((attachment, index) => (
									<PolicyCard key={index} href={attachment.file} title={attachment.title} />
								))}
							</Cards>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export const query = graphql`
	query PolicyServiceDevelopmentPageQuery {
		allContentJson(
			filter: { id: { regex: "/content\\/policy-and-service-development-page\\.json/" } }
		) {
			edges {
				node {
					main_heading
					main_body
					left_tile_heading
					left_tile_body
					left_tile_link_text
					left_tile_link_url
					right_tile_heading
					right_tile_body
					right_tile_link_text
					right_tile_link_url
					subheading
					body
					attachments {
						title
						file
					}
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/pages/policy-and-service-development/index.js